import { useTranslation } from 'react-i18next';
import { Button, DialogContent, IconButton, MenuItem, Stack } from '@mui/material';
import { ControlledSelect, ISupportCaseFoodRestriction, ISupportee } from '../../../shared';
import { Delete } from '@mui/icons-material';
import React, { FC } from 'react';
import { FullName } from '../full-name/full-name.component';
import { useFieldArray, UseFormReturn } from 'react-hook-form';
import { useFoodRestrictionsList } from '../../../admin/hooks/food-restriction.hook';

interface Props {
    supportees: ISupportee[];
    form: UseFormReturn<{ foodRestrictions: ISupportCaseFoodRestriction[] }>;
}

export const SupportCaseFoodRestrictionInputs: FC<Props> = ({ supportees, form }) => {
    const { t } = useTranslation();

    const { data: foodRestrictionList } = useFoodRestrictionsList({ pageSize: 100 });

    const { fields, append, remove } = useFieldArray({
        control: form.control,
        name: 'foodRestrictions',
    });

    return (
        <DialogContent>
            {fields.map((field, index) => (
                <Stack direction="row" spacing={2} key={field.id} mb={2}>
                    <ControlledSelect
                        name={`foodRestrictions.[${index}].supportee`}
                        defaultValue={'all'}
                        label={t('supportee')}
                        required
                    >
                        <MenuItem value={'all'} key={'all'}>{`${t('all')}`}</MenuItem>
                        {supportees?.map((item) => (
                            <MenuItem value={item.id} key={item.id}>
                                <FullName data={item} />
                            </MenuItem>
                        ))}
                    </ControlledSelect>

                    <ControlledSelect
                        name={`foodRestrictions.[${index}].foodRestriction`}
                        label={t('foodRestriction')}
                        defaultValue={''}
                        required
                    >
                        {foodRestrictionList?.data.map((item) => (
                            <MenuItem value={item.id} key={item.id}>
                                {`${item.name}`}
                            </MenuItem>
                        ))}
                    </ControlledSelect>

                    <IconButton onClick={() => remove(index)}>
                        <Delete />
                    </IconButton>
                </Stack>
            ))}
            <Button onClick={() => append({ supportee: 'all', foodRestriction: '' })} color="secondary">
                + {t('foodRestrictionAdd')}
            </Button>
        </DialogContent>
    );
};
